import * as THREE from 'three';
import { InsideType } from '../../../constants/enum';
import { GeometryUtils } from '../../../utils/geometry/GeometryUtils';
import ScaleFormularController from '../controllers/transform/ScaleFormularController';
import { EdgeDetector } from '../layout/EdgeDetector';

export class BaseModule {
  constructor(moduleData, moduleType, sceneManager) {
    this.id = this.generateId();
    this.moduleId = moduleData?.id;
    this.moduleData = { ...moduleData }; // Clone data để tránh reference
    this.moduleType = moduleType;
    this.sceneManager = sceneManager;

    // 3D properties
    this.group = null; // THREE.Group chứa 3D model
    this.thumbnail_url = moduleData?.thumbnail_url || null;

    this.listInside = [];
    // this.beveled = moduleData || false; //Mặc định là cửa kh vát cạnh cho từng module
    this.beveled = moduleData?.library_data?.beveled ?? false; //Mặc định là cửa kh vát cạnh cho từng module
    this.indexInside = 0;

    this.library_data = moduleData?.library_data || null;

    this.position = new THREE.Vector3();
    this.rotation = new THREE.Euler();
    this.scale = new THREE.Vector3(1, 1, 1);

    // Computed properties
    this.actualSize = new THREE.Vector3(); // Kích thước thực tế từ 3D model
    this.boundingBox = new THREE.Box3();

    this.exclude_types = moduleData?.exclude_types || [];

    // State
    this.isLoaded = false;
    this.isSelected = false;
    this.isVisible = true;

    // Custom properties có thể override
    this.customData = {};

    //Nếu có cả options ở moduleData và settings thì ưu tiên settings
    const mergedOptions = {
      ...(moduleData?.options || {}),
      ...(moduleData?.settings?.options || {}),
    };

    // Khởi tạo ScaleFormularController
    this.formularController = new ScaleFormularController(
      moduleData?.settings?.dimensions || moduleData?.default,
      // moduleData?.settings?.options || moduleData?.options,
      mergedOptions,
      null,
      moduleData?.cabinetFormular
    );

    if (Array.isArray(moduleData?.accessories)) {
      moduleData.accessories.forEach(accessory => {
        this.listInside.push({
          type: 86,
          name: accessory.name,
          unit: accessory.unit || null,
          quantity: accessory.quantity || null,
          price: accessory.price * accessory.quantity || null,
          ...accessory,
        });
      });
    }

    // Texture
    this.textures = new Map();

    this.fitCeiling = moduleData.fitCeiling || false; // đụng trần
  }

  /**
   * Module đụng trần
   */
  setFitCeiling(fitCeiling) {
    this.fitCeiling = fitCeiling;
    console.log('Set fitCeiling:', fitCeiling, this.fitCeiling);
  }

  generateId() {
    return `module_${Date.now()}_${Math.random().toString(36).substr(2, 9)}`;
  }

  changeBevelebModule(beveled) {
    if (beveled !== null && beveled !== undefined) {
      this.beveled = beveled;
    }
  }

  setInfoModelChild = gltfScene => {
    gltfScene?.traverse(child => {
      if (child.isMesh || child.isGroup) {
        child.userData.type = gltfScene.userData.type;

        if (gltfScene.userData.type === InsideType.DOOR) {
          child.userData.useAcrylic = gltfScene.userData?.useAcrylic || false;
        }

        child.userData.parentGltf = gltfScene.uuid;
        const size = GeometryUtils.getSize(child);
      }
    });
    const size = GeometryUtils.getSize(gltfScene);
  };

  // Load 3D model
  async load() {
    try {
      // Load model tạm ở (0,0,0)
      const tempPosition = new THREE.Vector3(0, 0, 0);
      this.group = await this.sceneManager.moduleLoader.loadModule(
        this.moduleData,
        tempPosition
      );

      //Scale module theo công thức
      this.scaleModuleWithFormular();

      // Tính kích thước thực tế
      this.updateBoundingBox();
      this.updateActualSize();

      // Update moduleData với kích thước thực tế
      // this.moduleData.width = this.actualSize.z;
      // this.moduleData.depth = this.actualSize.x;
      // this.moduleData.height = this.actualSize.y;

      this.isLoaded = true;

      this.group.traverse(child => {
        if (
          child.userData.type === InsideType.CLOTHES_HANGER &&
          child.userData.noInside === true
        ) {
          this.setInfoModelChild(child);
          const data = {
            type: child.userData.type,
            name: 'Thanh treo quần áo',
            group: child,
            gltf: child,
          };

          this.listInside.push(data);
        }
        if (
          child.userData.type === InsideType.DRAWER &&
          child.userData.noInside === true
        ) {
          this.setInfoModelChild(child);
          const data = {
            type: child.userData.type,
            name: 'Học kéo',
            group: child,
            gltf: child,
          };

          this.listInside.push(data);
        }
        if (
          child.userData.type === InsideType.DOOR &&
          child.userData.noInside === true
        ) {
          this.setInfoModelChild(child);
          const data = {
            type: child.userData.type,
            name: 'Cửa',
            group: child,
            gltf: child,
          };

          this.listInside.push(data);
        }
        if (child.name.includes('VAT-GIUONG')) {
          const data = {
            type: InsideType.BED_SLAT,
            name: 'Vạt Giường',
            group: child,
            gltf: child,
          };

          this.listInside.push(data);
        }
      });

      return this.group;
    } catch (error) {
      console.error(`Error loading module ${this.id}:`, error);
      throw error;
    }
  }

  // updateModuleGroupAfterScale(moduleGroup) {
  //   const clonedScene = moduleGroup.children?.find(
  //     child => child.type === 'Group' || child.type === 'Scene'
  //   );

  //   if (!clonedScene) return;

  //   // Lưu trạng thái hiện tại của moduleGroup
  //   const originalPosition = moduleGroup.position.clone();
  //   const originalRotation = moduleGroup.rotation.clone();
  //   const originalQuaternion = moduleGroup.quaternion.clone();

  //   // Tạm thời đưa moduleGroup về gốc tọa độ và góc quay 0
  //   moduleGroup.position.set(0, 0, 0);
  //   moduleGroup.rotation.set(0, 0, 0);
  //   moduleGroup.quaternion.set(0, 0, 0, 1);

  //   // Cập nhật matrix để các thay đổi có hiệu lực
  //   moduleGroup.updateMatrixWorld(true);

  //   // Bây giờ tính toán bounding box trong trạng thái "chuẩn"
  //   const box = new THREE.Box3().setFromObject(clonedScene);
  //   const newSize = new THREE.Vector3();
  //   box.getSize(newSize);
  //   const newCenter = new THREE.Vector3();
  //   box.getCenter(newCenter);
  //   newCenter.y = box.min.y; // Đặt center ở đáy

  //   // Điều chỉnh pivot của clonedScene
  //   clonedScene.position.sub(newCenter);
  //   clonedScene.updateMatrixWorld(true);

  //   // Khôi phục lại trạng thái ban đầu của moduleGroup
  //   moduleGroup.position.copy(originalPosition);
  //   moduleGroup.rotation.copy(originalRotation);
  //   moduleGroup.quaternion.copy(originalQuaternion);

  //   // Cập nhật matrix cuối cùng
  //   moduleGroup.updateMatrixWorld(true);
  // }

  // Hàm mới
  updateModuleGroupAfterScale(moduleGroup) {
    const originalPosition = moduleGroup.position.clone();
    const originalQuaternion = moduleGroup.quaternion.clone();

    // Reset về gốc để tính toán chính xác
    moduleGroup.position.set(0, 0, 0);
    moduleGroup.quaternion.set(0, 0, 0, 1);
    moduleGroup.updateMatrixWorld(true);

    let checkLeg = false;

    moduleGroup.traverse(mesh => {
      if (checkLeg) return;

      if (
        mesh.userData.isInside === true &&
        (mesh.userData.type === InsideType.CHAN_ROI_TV ||
          mesh.userData.type === InsideType.KHUNG_SAT)
      ) {
        checkLeg = true;
      }
    });

    const box = new THREE.Box3().setFromObject(
      GeometryUtils.moduleOnlyFrame(moduleGroup)
    );
    const center = new THREE.Vector3();
    box.getCenter(center);
    center.y = box.min.y;

    if (
      !checkLeg ||
      center.y ===
        moduleGroup?.userData?.moduleData?.settings?.options?.caoChanRoi
    ) {
      center.y -=
        moduleGroup?.userData?.moduleData?.settings?.options?.caoChanRoi || 0;
    }

    // Dịch tất cả children
    moduleGroup.children.forEach(child => {
      if (child.userData.isInside) return; // Không dịch các phần tử bên trong
      child.position.sub(center);
    });

    // // Bù offset vào position để vị trí thực tế không đổi
    // moduleGroup.position
    //   .copy(originalPosition)
    //   .add(center.clone().applyQuaternion(originalQuaternion));
    // moduleGroup.quaternion.copy(originalQuaternion);
    // moduleGroup.updateMatrixWorld(true);

    // Giữ nguyên vị trí cũ
    moduleGroup.position.copy(originalPosition);
    moduleGroup.quaternion.copy(originalQuaternion);
    moduleGroup.updateMatrixWorld(true);
  }

  // Update bounding box
  updateBoundingBox() {
    if (this.group) {
      // this.boundingBox.setFromObject(this.group);
      this.boundingBox.setFromObject(GeometryUtils.moduleOnlyFrame(this.group));
    }
  }

  // Update kích thước thực tế
  updateActualSize() {
    if (this.group) {
      this.updateBoundingBox();
      this.boundingBox.getSize(this.actualSize);
    }
  }

  // Scale theo công thức
  scaleModuleWithFormular(mdDimensions = {}, mdOptions = {}) {
    // Áp dụng công thức scaling module
    const moduleGltfScale = this.formularController.applyFormulaScaling(
      this.group,
      mdDimensions,
      mdOptions
    );

    //Hiển thị hậu tương ứng
    if (this.formularController.currentOptions.hauNgang !== undefined) {
      GeometryUtils.handleShowBackPanel(
        this.group,
        this.formularController.currentOptions.hauNgang
      );
    }

    const defaultSize = moduleGltfScale.userData.moduleData?.default || {};
    moduleGltfScale.userData.currentSize = {
      ...defaultSize,
      ...mdDimensions,
      ...mdOptions,
    };

    // Tạo vách lam bằng code
    this._replaceWithGeneratedLamPanel(moduleGltfScale);

    this.updateModuleGroupAfterScale(moduleGltfScale);

    return moduleGltfScale;
  }

  _replaceWithGeneratedLamPanel(moduleGltfScale) {
    const vachLam = moduleGltfScale.getObjectByName('VACH-LAM');
    if (!vachLam) return;

    //Ẩn vách lam gốc
    vachLam.visible = false;

    const existing = moduleGltfScale.getObjectByName('VACH-LAM-GENERATED');
    if (existing) existing.parent?.remove(existing);

    vachLam.updateMatrixWorld(true);

    const box = new THREE.Box3().setFromObject(vachLam);
    const size = new THREE.Vector3();
    box.getSize(size);

    const vachLamSize = {
      x: Math.max(size.x, size.z),
      y: size.y,
      z: Math.min(size.x, size.z),
    };

    const lamGroup = this._createLamPanel(
      vachLamSize.x,
      vachLamSize.y,
      vachLamSize.z,
      vachLam
    );
    lamGroup.name = 'VACH-LAM-GENERATED';

    // Lấy world position của VACH-TRON
    const worldPos = new THREE.Vector3();
    vachLam.getWorldPosition(worldPos);

    // Convert position về local space của moduleGltfScale
    const localPos = moduleGltfScale.worldToLocal(worldPos);
    lamGroup.position.copy(localPos);

    lamGroup.rotation.set(0, Math.PI / 2, 0);

    moduleGltfScale.add(lamGroup);
  }

  _createLamPanel(width, height, depth, referenceMesh, options = {}) {
    const material =
      referenceMesh?.material?.clone?.() ??
      new THREE.MeshStandardMaterial({ color: 0xaaaaaa });

    const GAP = 0.006;
    const MIN_SLAT = 0.025;

    const numSlats =
      options.numSlats ?? Math.floor((width + GAP) / (MIN_SLAT + GAP));
    const slatThick = (width - (numSlats - 1) * GAP) / numSlats;

    const slatDepth = 0.006;
    const baseDepth = depth - slatDepth;

    const group = new THREE.Group();

    //Tấm nền
    const baseGeo = new THREE.BoxGeometry(width, height, baseDepth);
    const baseMesh = new THREE.Mesh(baseGeo, material);
    baseMesh.position.set(width / 2, height / 2, baseDepth / 2);
    baseMesh.name = 'LAM_BASE';
    group.add(baseMesh);

    //Các lam dọc
    for (let i = 0; i < numSlats; i++) {
      const x = i * (slatThick + GAP) + slatThick / 2;
      const slatGeo = new THREE.BoxGeometry(slatThick, height, slatDepth);
      const slatMesh = new THREE.Mesh(slatGeo, material);
      slatMesh.position.set(x, height / 2, baseDepth + slatDepth / 2);
      slatMesh.name = `LAM_SLAT_${i}`;
      group.add(slatMesh);
    }

    return group;
  }

  // Set vị trí
  setPosition(position) {
    this.position.copy(position);
    if (this.group) {
      this.group.position.copy(position);
    }
  }

  // Set rotation
  setRotation(rotation) {
    this.rotation.copy(rotation);
    if (this.group) {
      this.group.rotation.copy(rotation);
    }
  }

  // Set scale
  setScale(scale) {
    this.scale.copy(scale);
    if (this.group) {
      this.group.scale.copy(scale);
    }
  }

  // Show/hide module
  setVisible(visible) {
    this.isVisible = visible;
    if (this.group) {
      this.group.visible = visible;
    }
  }

  // Select/deselect module
  setSelected(selected) {
    this.isSelected = selected;
    // Có thể thêm visual feedback ở đây
    if (this.group) {
      // Ví dụ: thay đổi material hoặc thêm outline
    }
  }

  // Dispose module
  dispose() {
    if (this.group) {
      this.sceneManager.scene.remove(this.group);
      // Dispose materials và geometries nếu cần
      this.group.traverse(child => {
        if (child.geometry) child.geometry.dispose();
        if (child.material) {
          if (Array.isArray(child.material)) {
            child.material.forEach(mat => mat.dispose());
          } else {
            child.material.dispose();
          }
        }
      });
    }
  }

  // Get data để serialize
  getData() {
    return {
      id: this.id,
      moduleData: this.moduleData,
      moduleType: this.moduleType,
      position: this.position.toArray(),
      rotation: this.rotation.toArray(),
      scale: this.scale.toArray(),
      isVisible: this.isVisible,
      actualSize: this.actualSize.toArray(),
      customData: this.customData,
    };
  }

  // Load từ data đã serialize
  static fromData(data, sceneManager) {
    const module = new BaseModule(
      data.moduleData,
      data.moduleType,
      sceneManager
    );
    module.id = data.id;
    module.position.fromArray(data.position);
    module.rotation.fromArray(data.rotation);
    module.scale.fromArray(data.scale);
    module.isVisible = data.isVisible;
    module.actualSize.fromArray(data.actualSize);
    module.customData = data.customData || {};
    return module;
  }

  getMeshPoints() {
    const orientation = GeometryUtils.getModuleOrientation(this.group);
    if (orientation === 'NORMAL' || orientation === 'ROTATED_180') {
      return EdgeDetector.findMeshPoints(this.group);
    } else if (orientation === 'ROTATED_90' || orientation === 'ROTATED_270') {
      return EdgeDetector.findMeshPointsRotation(this.group);
    }
  }

  /**
   * Tìm vị trí tối ưu cho module - kiểm tra tường 1 trước, sau đó tường 2
   */
  findOptimalPosition(yPosition) {
    const wallThickness = this.sceneManager.wallThickness;

    const leftWall = this.sceneManager.walls.find(
      wall => wall.mesh.position.x < 0
    );
    const backWall = this.sceneManager.walls.find(
      wall => wall.mesh.position.z < 0
    );

    // 1. Kiểm tra tường 1 (tường sau) trước
    const wall1Position = this.findPositionOnWall1(
      leftWall,
      backWall,
      wallThickness,
      yPosition
    );
    if (wall1Position.found) {
      return wall1Position;
    }

    // 2. Nếu tường 1 đầy, chuyển sang tường 2 (tường trái)
    const wall2Position = this.findPositionOnWall2(
      leftWall,
      backWall,
      wallThickness,
      yPosition
    );
    if (wall2Position.found) {
      return wall2Position;
    }

    // 3. Fallback: tìm vị trí bất kỳ còn available

    return this.findAvailablePosition(this.actualSize, yPosition);
  }

  getFloorBounds() {
    const floorSize = this.sceneManager.getFloorSize();

    // Tính bounds thực tế có thể đặt module (trừ wall thickness)
    return {
      minX: -floorSize.width / 2,
      maxX: floorSize.width / 2,
      minZ: -floorSize.depth / 2,
      maxZ: floorSize.depth / 2,
    };
  }

  /**
   * Lấy tất cả modules cùng loại đang có trong 3D scene
   */
  getExistingModulesIn3D() {
    if (!this.cabinet) return [];

    return this.cabinet
      .getModulesByType(this.cabinetType)
      .filter(module => {
        // Chỉ lấy modules có group và đã được add vào scene
        return (
          module.id !== this.id &&
          module.group &&
          module.group.parent && // Đảm bảo đã được add vào scene
          module.position // Có position
        );
      })
      .map(module => ({
        id: module.id,
        position: module.group.position.clone(), // Lấy position trực tiếp từ 3D object
        rotation: module.group.rotation.clone(), // Lấy rotation trực tiếp từ 3D object
        // size:GeometryUtils.getSize(module.group),
        size: GeometryUtils.getSizeRotation(module.group, module.group),
        moduleType: module.cabinetType,
        group: module.group,
      }));
  }

  getMinZ(moduleData) {
    const sizeZ = moduleData.size?.z ?? 0;
    const posZ = moduleData.position?.z ?? 0;
    return posZ - sizeZ / 2;
  }

  getMinX(moduleData) {
    const sizeX = moduleData.size?.x ?? 0;
    const posX = moduleData.position?.x ?? 0;
    return posX - sizeX / 2;
  }

  /**
   * Tìm vị trí trên tường 1 (tường sau)
   */
  findPositionOnWall1(leftWall, backWall, wallThickness, yPosition) {
    const rotation = new THREE.Euler(0, -Math.PI / 2, 0);
    const bounds = this.getFloorBounds();

    const startXBackWall = backWall
      ? backWall.mesh.position.x - backWall.size[0] / 2
      : 0;
    const startZBackWall = backWall
      ? backWall.mesh.position.z + wallThickness / 2
      : 0;
    const endZBackWall = backWall
      ? backWall.mesh.position.z + wallThickness / 2 + this.actualSize.x
      : 0;

    // Lấy modules đang có trong 3D scene
    const existingModules = this.getExistingModulesIn3D();

    const getHeightY = size => size?.y ?? size?.[1] ?? 0;

    // Lọc các module trên tường 1 (dựa vào rotation và position)
    const wall1Modules = existingModules
      .filter(moduleData => {
        const minZ = this.getMinZ(moduleData);
        // const zInRange =
        //   moduleData.position.z >= startZBackWall &&
        //   moduleData.position.z <= endZBackWall;
        const zInRange = minZ <= endZBackWall;
        let heightOk;
        if (moduleData.position.y < yPosition) {
          heightOk =
            (moduleData.position?.y ?? 0) + getHeightY(moduleData.size) >
            (yPosition ?? 0);
        } else {
          heightOk =
            (yPosition ?? 0) + this.actualSize.y >
            (moduleData.position?.y ?? 0);
        }
        return zInRange && heightOk;
      })
      .sort((a, b) => a.position.x - b.position.x); // Sắp xếp theo x

    // Nếu chưa có module nào trên tường 1
    if (wall1Modules.length === 0) {
      const candidateX = startXBackWall + this.actualSize.z / 2;
      const candidateZ = startZBackWall + this.actualSize.x / 2;
      const testPosition = new THREE.Vector3(candidateX, 0, candidateZ);

      if (this.isValidPosition(testPosition, rotation)) {
        return {
          position: testPosition,
          rotation: rotation,
          found: true,
        };
      }
    }

    // Tìm khoảng trống giữa các modules trên tường 1
    for (let i = 0; i <= wall1Modules.length; i++) {
      let candidateX;

      if (i === 0) {
        // Vị trí đầu tiên
        candidateX = startXBackWall + this.actualSize.z / 2;
        if (wall1Modules.length > 0) {
          const firstModule = wall1Modules[0];
          const requiredSpace =
            firstModule.position.x -
            firstModule.size.z / 2 -
            candidateX +
            this.actualSize.z / 2;
          if (requiredSpace < 0) {
            continue; // Không đủ chỗ
          }
        }
      } else if (i === wall1Modules.length) {
        // Vị trí cuối cùng
        const lastModule = wall1Modules[i - 1];
        candidateX =
          lastModule.position.x + lastModule.size.z / 2 + this.actualSize.z / 2;
      } else {
        // Vị trí giữa hai modules
        const prevModule = wall1Modules[i - 1];
        const nextModule = wall1Modules[i];
        const availableSpace =
          nextModule.position.x -
          nextModule.size.z / 2 -
          (prevModule.position.x + prevModule.size.z / 2);

        if (availableSpace < this.actualSize.z - 0.0001) {
          continue; // Không đủ chỗ
        }

        candidateX =
          prevModule.position.x + prevModule.size.z / 2 + this.actualSize.z / 2;
      }

      const testPosition = new THREE.Vector3(
        candidateX,
        0,
        startZBackWall + this.actualSize.x / 2
      );

      if (this.isValidPosition(testPosition, rotation, yPosition)) {
        return {
          position: testPosition,
          rotation: rotation,
          found: true,
        };
      }
    }

    return { found: false };
  }

  /**
   * Tìm vị trí trên tường 2 (tường trái)
   */
  findPositionOnWall2(leftWall, backWall, wallThickness, yPosition) {
    const rotation = new THREE.Euler(0, 0, 0); // Module hướng ra ngoài từ tường trái
    const bounds = this.getFloorBounds();

    // Tính toán vị trí bắt đầu và kết thúc của tường trái
    const startZLeftWall = leftWall
      ? leftWall.mesh.position.z - leftWall.size[0] / 2
      : 0;
    const startXLeftWall = leftWall
      ? leftWall.mesh.position.x + wallThickness / 2
      : 0;
    const endXLeftWall = leftWall
      ? leftWall.mesh.position.x + leftWall.size[0] / 2 + this.actualSize.x
      : 0;

    // Lấy modules đang có trong 3D scene
    const existingModules = this.getExistingModulesIn3D();

    const getHeightY = size => size?.y ?? size?.[1] ?? 0;

    // Lọc các module trên tường 2 (dựa vào overlap với khu vực tường)
    const wall2Modules = existingModules
      .filter(moduleData => {
        const minX = this.getMinX(moduleData);
        // const zInRange =
        //   moduleData.position.z >= startZBackWall &&
        //   moduleData.position.z <= endZBackWall;
        const zInRange = minX <= endXLeftWall;
        let heightOk;
        if (moduleData.position.y < yPosition) {
          heightOk =
            (moduleData.position?.y ?? 0) + getHeightY(moduleData.size) >
            (yPosition ?? 0);
        } else {
          heightOk =
            (yPosition ?? 0) + this.actualSize.y >
            (moduleData.position?.y ?? 0);
        }
        return zInRange && heightOk;
      })
      .sort((a, b) => b.position.z - a.position.z); // Sắp xếp theo x NGƯỢC LẠI (từ phải sang trái)

    // Nếu chưa có module nào trên tường 2
    if (wall2Modules.length === 0) {
      const candidateX = startXLeftWall + this.actualSize.x / 2;
      const candidateZ = startZLeftWall + this.actualSize.z / 2;
      const testPosition = new THREE.Vector3(candidateX, 0, candidateZ);

      if (this.isValidPosition(testPosition, rotation)) {
        return {
          position: testPosition,
          rotation: rotation,
          found: true,
        };
      }
    }

    // Tìm khoảng trống giữa các modules trên tường 2 (từ phải sang trái)
    for (let i = 0; i <= wall2Modules.length; i++) {
      let candidateZ;
      const module = wall2Modules[i];
      candidateZ = module
        ? module.position.z +
          this.getModule3DSize(module.group).z / 2 +
          this.actualSize.z / 2
        : 0;

      const testPosition = new THREE.Vector3(
        startXLeftWall + this.actualSize.x / 2,
        0,
        candidateZ
      );

      if (this.isValidPosition(testPosition, rotation, yPosition)) {
        return {
          position: testPosition,
          rotation: rotation,
          found: true,
        };
      }
    }

    return { found: false };
  }

  /**
   * Kiểm tra vị trí có hợp lệ không (trong bounds và không va chạm)
   */
  isValidPosition(position, rotation, yPosition) {
    return (
      !this.isOutOfFloorBounds(position, this.actualSize, rotation) &&
      !this.checkCollisionWithOtherModules(
        position,
        this.actualSize,
        rotation,
        this.id,
        yPosition
      )
    );
  }

  /**
   * Kiểm tra va chạm với modules khác trong 3D scene
   */
  checkCollisionWithOtherModules(
    position,
    size,
    rotation,
    excludeModuleId = null,
    yPosition
  ) {
    if (!this.cabinet) return false;

    // Lấy modules đang có trong 3D scene
    const existingModules = this.getExistingModulesIn3D();
    const { width, depth } = this.getRotatedSize(size, rotation);

    // Tạo bounding box cho module hiện tại
    const currentBox = new THREE.Box3(
      new THREE.Vector3(
        position.x - width / 2,
        yPosition,
        position.z - depth / 2
      ),
      new THREE.Vector3(
        position.x + width / 2,
        yPosition,
        position.z + depth / 2
      )
    );

    // Kiểm tra va chạm với từng module trong 3D
    for (const moduleData of existingModules) {
      if (excludeModuleId && moduleData.id === excludeModuleId) {
        continue;
      }

      // Tính toán bounding box của module hiện tại trong scene
      const moduleRotation = moduleData.rotation;
      const moduleRotatedSize = this.getRotatedSize(
        moduleData.size,
        moduleRotation
      );

      const moduleBox = new THREE.Box3(
        new THREE.Vector3(
          moduleData.position.x - moduleRotatedSize.width / 2,
          moduleData.position.y - moduleData.size.y / 2,
          moduleData.position.z - moduleRotatedSize.depth / 2
        ),
        new THREE.Vector3(
          moduleData.position.x + moduleRotatedSize.width / 2,
          moduleData.position.y + moduleData.size.y / 2,
          moduleData.position.z + moduleRotatedSize.depth / 2
        )
      );

      // Kiểm tra va chạm chi tiết
      const intersects = currentBox.intersectsBox(moduleBox);

      // Kiểm tra chỉ chạm nhau tại một điểm (không phải va chạm thực sự)
      const xTouching =
        Math.abs(currentBox.max.x - moduleBox.min.x) < 0.001 ||
        Math.abs(currentBox.min.x - moduleBox.max.x) < 0.001;
      const zTouching =
        Math.abs(currentBox.max.z - moduleBox.min.z) < 0.001 ||
        Math.abs(currentBox.min.z - moduleBox.max.z) < 0.001;

      // Nếu chỉ chạm nhau tại cạnh (không overlap thực sự) thì không coi là va chạm
      if (
        (xTouching && !zTouching) ||
        (zTouching && !xTouching) ||
        (xTouching && zTouching)
      ) {
        continue;
      }

      if (intersects) {
        return true; // Va chạm thực sự
      }
    }

    return false; // Không va chạm
  }

  getModule3DSize(group) {
    if (!group) return new THREE.Vector3(0, 0, 0);

    // Cập nhật toàn bộ matrix world trước khi tính bounding box
    group.updateWorldMatrix(true, true);

    const box = new THREE.Box3().setFromObject(group);
    const size = new THREE.Vector3();
    box.getSize(size);
    return size;
  }

  /**
   * Kiểm tra module có vượt quá giới hạn sàn không
   */
  isOutOfFloorBounds(position, size, rotation) {
    const bounds = this.getFloorBounds();

    // Tính toán bounding box dựa trên rotation
    const { width, depth } = this.getRotatedSize(size, rotation);

    const minX = position.x - width / 2;
    const maxX = position.x + width / 2;
    const minZ = position.z - depth / 2;
    const maxZ = position.z + depth / 2;

    return (
      minX < bounds.minX ||
      maxX > bounds.maxX ||
      minZ < bounds.minZ ||
      maxZ > bounds.maxZ
    );
  }

  /**
   * Lấy kích thước đã xoay của module
   */
  getRotatedSize(size, rotation) {
    const angle = Math.abs(rotation.y) % (Math.PI * 2);

    // Nếu xoay 90 hoặc 270 độ thì đổi width và depth
    if (
      Math.abs(angle - Math.PI / 2) < 0.1 ||
      Math.abs(angle - (3 * Math.PI) / 2) < 0.1
    ) {
      return {
        width: size.z, // depth becomes width
        depth: size.x, // width becomes depth
      };
    }

    return {
      width: size.x,
      depth: size.z,
    };
  }

  /**
   * Tìm vị trí available bất kỳ trong phòng (fallback method)
   */
  findAvailablePosition(size, yPosition) {
    const bounds = this.getFloorBounds();
    const stepSize = Math.min(size.x, size.z) / 2; // Bước nhảy để scan

    // Thử các rotation khác nhau
    const rotations = [
      new THREE.Euler(0, 0, 0), // 0 degrees
      new THREE.Euler(0, Math.PI / 2, 0), // 90 degrees
      new THREE.Euler(0, Math.PI, 0), // 180 degrees
      new THREE.Euler(0, -Math.PI / 2, 0), // 270 degrees
    ];

    for (const rotation of rotations) {
      const { width, depth } = this.getRotatedSize(size, rotation);

      // Scan từ góc phòng
      for (
        let x = bounds.minX + width / 2;
        x <= bounds.maxX - width / 2;
        x += stepSize
      ) {
        for (
          let z = bounds.minZ + depth / 2;
          z <= bounds.maxZ - depth / 2;
          z += stepSize
        ) {
          const testPosition = new THREE.Vector3(x, 0, z);

          if (this.isValidPosition(testPosition, rotation, yPosition)) {
            return {
              position: testPosition,
              rotation: rotation,
              found: true,
            };
          }
        }
      }
    }

    // Nếu không tìm thấy vị trí nào, trả về vị trí mặc định
    console.warn(`Cannot find available position for module ${this.id}`);
    return {
      position: new THREE.Vector3(0, 0, 0),
      rotation: new THREE.Euler(0, 0, 0),
      found: false,
    };
  }
}
